var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEducation = function SvgEducation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3021 10.0104L19.0417 10.5729L18.7709 10.6979L18.0313 11.0208L12.698 13.3958C12.5625 13.4583 12.4375 13.4896 12.2917 13.5104C12.0729 13.5521 11.8438 13.5521 11.625 13.5104C11.4792 13.4896 11.3542 13.4583 11.2188 13.3958L5.88545 11.0208L5.14588 10.6979L4.87503 10.5729L3.61462 10.0104C2.60421 9.5625 2.60421 8.41665 3.61462 7.96873L11.2188 4.58331C11.6771 4.39581 12.2396 4.39581 12.698 4.58331L20.3021 7.96873C21.3125 8.40623 21.3125 9.5625 20.3021 10.0104Z",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0313 11.0208V15.0104C18.0313 15.3646 17.8646 15.698 17.5625 15.8959C16.5834 16.5417 14.6146 17.5937 11.9584 17.5937C11.1459 17.5937 8.75004 17.5 6.35421 15.8959C6.06254 15.698 5.89587 15.3646 5.89587 15.0104V11.0312L11.2292 13.4063C11.3646 13.4688 11.4896 13.5 11.6355 13.5208C11.8542 13.5625 12.0834 13.5625 12.3021 13.5208C12.448 13.5 12.573 13.4688 12.7084 13.4063L18.0313 11.0208Z",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 8.98962V18.3542",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 16.5C20.0417 16.5 19.2084 17.3334 19.2084 18.3542C19.2084 19.375 20.0417 20.2083 21.0625 20.2083C22.0834 20.2083 22.9167 19.375 22.9167 18.3542C22.9167 17.3334 22.0834 16.5 21.0625 16.5Z",
    fill: "#858585"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 19.4271V21.5625",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEducation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/education.ee1fd6fd.svg";
export { ForwardRef as ReactComponent };